import React from "react";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import { palette } from "../../styles/palette";

interface BetOutcomeIconProps {
  outcome: number;
  styles?: React.CSSProperties;
}

// outcome mirrors the backend BetOutcome enum: 0 = wrong, 1 = correct
// (right outcome), 2 = perfect (exact score, shown with the stronger double-check).
const BetOutcomeIcon: React.FC<BetOutcomeIconProps> = ({ outcome, styles }) => {
  switch (outcome) {
    case 0:
      return (
        <ClearOutlinedIcon
          style={{ ...styles, color: palette.betWrong, margin: "3px" }}
        />
      );
    case 1:
      return (
        <CheckOutlinedIcon
          style={{ ...styles, color: palette.betCorrect, margin: "3px" }}
        />
      );
    case 2:
      return (
        <DoneAllOutlinedIcon
          style={{ ...styles, color: palette.betPerfect, margin: "3px" }}
        />
      );
    default:
      return <div></div>;
  }
};

export default BetOutcomeIcon;
